import Stack from "@mui/material/Stack";
import type { ReactElement } from "react";
import {
  type BottomReadyButtonProps,
  BottomReadyButton,
} from "./BottomReadyButton";
import { type HeroProps, HeroComponent } from "./HeroComponent";
import { MdaiDivider } from "./MdaiDivider";
import { type TabContentProps, TabsSection } from "./Tabs/TabsSection";

interface TopTabsProps {
  headline?: string | ReactElement;
  subhead?: string;
  tabs: TabContentProps[];
  details?: string | ReactElement;
  caption?: string | ReactElement;
  button?: boolean;
}

interface PageTemplateProps {
  id: string;
  hero: HeroProps;
  showHero?: boolean;
  topTabs?: TopTabsProps;
  sections?: ReactElement;
  bottomButton?: BottomReadyButtonProps;
  showDividerBottom?: boolean;
  showDividerTop?: boolean;
}

export const PageTemplate = ({
  id,
  hero,
  showHero = true,
  topTabs,
  sections,
  bottomButton,
  showDividerBottom = true,
  showDividerTop = true,
}: PageTemplateProps) => {
  return (
    <Stack
      gap={{ sm: 4, md: 5, lg: 5 }}
      mx={{ lg: 4 }}
      justifyContent={"center"}
    >
      {showHero && <HeroComponent {...hero} />}

      {topTabs && (
        <TabsSection
          id={id}
          headline={topTabs.headline}
          subhead={topTabs.subhead}
          contentList={topTabs.tabs}
          caption={topTabs.caption}
          button={topTabs.button}
          contentSize={{
            height: { sm: "auto", md: "100%", lg: "640px" },
            width: { sm: "100%", md: "100%", lg: "900px" },
          }}
        />
      )}

      {showDividerTop && <MdaiDivider />}

      <Stack alignItems="center" gap={10}>
        {sections}
      </Stack>

      {bottomButton && (
        <>
          {showDividerBottom && <MdaiDivider />} <BottomReadyButton {...bottomButton} />
        </>
      )}
    </Stack>
  );
};
